/* © CNES */
import { filterSections } from '../../../../../assets/config/filters/Referenciel';
import { SelectButtonItem } from '../../../../../models/SelectButtonItem';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { FilterSelectButtons } from '../FilterSelectButtons/FilterSelectButtons';

/**
 * Product Type Condition Props.
 */
interface DataProductConditionProps {
  dataProductOptions: SelectButtonItem[] | null;
  handleChange: (e: any, key: string) => void;
}

/**
 * Product types Condition to display other filters depending on data product selection.
 * @param dataProductOptions all data product for selected Missions / Platforms.
 * @param handleChange Function to handle change on data product selection.
 * @returns DataProductCondition Element.
 */
export const DataProductCondition = ({
  dataProductOptions,
  handleChange,
}: DataProductConditionProps) => {
  /**
   * set new values of product type button select
   * @param value The product type to handle.
   */
  const onChangeProductType = (value: string | number[]) => {
    handleChange(value, filterSections.dataProduct.param);
  };
  return (
    <div className="dataProductFilter">
      <CustomAccordion
        title={filterSections.dataProduct.title}
        children={
          dataProductOptions && dataProductOptions.length > 0 ? (
            <FilterSelectButtons
              name={filterSections.dataProduct.param}
              options={dataProductOptions}
              handleChange={onChangeProductType}
            />
          ) : (
            <div>Please select a mission first.</div>
          )
        }
      />
    </div>
  );
};
